module.exports = __webpack_public_path__ + "static/media/30.b13f44ff.jpg";